module.exports = __webpack_public_path__ + "img/commission-failure.52ccf83a.svg";